import React from 'react';

export const Input = ({ className, children, variant, contentKey, ...props }) => {
  return (
    <input required className={className} {...props} />
  );
};

